import ModelDetails from './ModelDetailsContainer';

export default ModelDetails;
